import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-toolbar w-100" }
const _hoisted_4 = { class: "d-flex gap-1 justify-content-end w-100 mb-2 mx-2" }
const _hoisted_5 = {
  class: "btn btn-primary ps-2 pe-3 py-3",
  type: "button"
}
const _hoisted_6 = { class: "svg-icon svg-icon-2 me-0" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Tambah Data ")
const _hoisted_8 = {
  key: 0,
  class: "d-flex flex-wrap gap-2",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_9 = { style: {"width":"15rem"} }
const _hoisted_10 = { style: {"width":"11rem"} }
const _hoisted_11 = { class: "d-flex align-items-center position-relative" }
const _hoisted_12 = { class: "svg-icon position-absolute ms-6" }
const _hoisted_13 = {
  key: 1,
  class: "d-flex justify-content-end align-items-center w-100",
  "data-kt-customer-table-toolbar": "selected"
}
const _hoisted_14 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder me-5 ms-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-2" }, "Pilih Semua")
], -1)
const _hoisted_16 = { class: "card-body pt-0" }
const _hoisted_17 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_18 = ["value"]
const _hoisted_19 = ["href"]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen text-warning" })
], -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash text-danger" })
], -1)
const _hoisted_26 = [
  _hoisted_25
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, { to: "/media_file/add" }, {
            default: _withCtx(() => [
              _createElementVNode("button", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr075.svg" })
                ]),
                _hoisted_7
              ])
            ]),
            _: 1
          })
        ]),
        (_ctx.checkedNews.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_el_date_picker, {
                  placeholder: "Select a date",
                  type: "datetimerange",
                  modelValue: _ctx.filterTanggal,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterTanggal) = $event)),
                  shortcuts: _ctx.filterTanggalShortcut,
                  onChange: _ctx.filterDateChange,
                  "start-placeholder": "Tanggal Awal",
                  "end-placeholder": "Tanggal Akhir",
                  "default-time": _ctx.defaultTime,
                  style: {"width":"100%"},
                  class: "me-1"
                }, null, 8, ["modelValue", "shortcuts", "onChange", "default-time"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
                    onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchItems())),
                    class: "form-control form-control-solid w-200px ps-15",
                    placeholder: "Cari File",
                    style: {"height":"42px"}
                  }, null, 544), [
                    [_vModelText, _ctx.search]
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.is_select_all) = $event)),
                  onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.checkAll && _ctx.checkAll(...args)))
                }, null, 544), [
                  [_vModelCheckbox, _ctx.is_select_all]
                ])
              ]),
              _hoisted_15,
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-danger btn-sm ms-auto",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.deleteSelected && _ctx.deleteSelected(...args)))
              }, " Hapus " + _toDisplayString(_ctx.checkedNews.length) + " Data Terpilih ", 1)
            ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_Datatable, {
        "table-data": _ctx.tableData,
        "table-header": _ctx.tableHeader,
        "enable-items-per-page-dropdown": true,
        key: _ctx.tableKey,
        total: _ctx.total_data,
        "rows-per-page": _ctx.itemsPerPage,
        "current-page": _ctx.currentPage,
        loading: _ctx.is_loading,
        onCurrentChange: _ctx.currentChange,
        onItemsPerPageChange: _ctx.itemsPerPageChange
      }, {
        "cell-checkbox": _withCtx(({ row: file }) => [
          _createElementVNode("div", _hoisted_17, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              value: file._id,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.checkedNews) = $event))
            }, null, 8, _hoisted_18), [
              [_vModelCheckbox, _ctx.checkedNews]
            ])
          ])
        ]),
        "cell-account": _withCtx(({ row: file }) => [
          _createTextVNode(_toDisplayString(file.account || '-'), 1)
        ]),
        "cell-rubrics": _withCtx(({ row: file }) => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(file.rubrics, (rubric, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(rubric.name || '-'), 1))
          }), 128))
        ]),
        "cell-page": _withCtx(({ row: file }) => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(file.rubrics, (rubric, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(rubric.page || '-'), 1))
          }), 128))
        ]),
        "cell-file_source": _withCtx(({ row: file }) => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(file.rubrics, (rubric, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              (rubric.file_source && rubric.file_source !== 'string')
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: rubric.file_source,
                    target: "_blank"
                  }, " File " + _toDisplayString(index + 1), 9, _hoisted_19))
                : (_openBlock(), _createElementBlock("span", _hoisted_20, "-"))
            ]))
          }), 128))
        ]),
        "cell-created_by": _withCtx(({ row: file }) => [
          _createTextVNode(_toDisplayString(file.created_by || '-'), 1)
        ]),
        "cell-date": _withCtx(({ row: file }) => [
          _createTextVNode(_toDisplayString(_ctx.formatDate(file.date)), 1)
        ]),
        "cell-actions": _withCtx(({ row: file }) => [
          _createElementVNode("button", {
            onClick: ($event: any) => (_ctx.editItem(file._id)),
            type: "button",
            class: "btn btn-icon btn-bg-light btn-active-color-warning btn-sm me-1"
          }, _hoisted_23, 8, _hoisted_21),
          _createElementVNode("button", {
            onClick: ($event: any) => (_ctx.deleteItem(file._id)),
            type: "button",
            class: "btn btn-icon btn-bg-light btn-active-color-danger btn-sm me-1"
          }, _hoisted_26, 8, _hoisted_24)
        ]),
        _: 1
      }, 8, ["table-data", "table-header", "total", "rows-per-page", "current-page", "loading", "onCurrentChange", "onItemsPerPageChange"])
    ])
  ]))
}